module.exports = __webpack_public_path__ + "img/humidity.6d342953.svg";